<form [formGroup]="notificationForm">
	<div class="sale-admin-notification-setting-popup">
		<div class="modal-header">
			<h5 class="modal-title" *ngIf="data?.tab" id="permissionModalLabel">Sale Admin Notification Settings</h5>
			<div class="d-flex justify-content-end ms-auto">
				<button type="button" class="btn col-auto me-2 btn-secondary" (click)="closePopup()" *ngIf="tab == notificationSaleAdminTabs.ADD"><i class="fa fa-times"></i> Cancel</button>
				<button type="button" class="btn col-auto btn-primary" (click)="submit()" [disabled]="validateSubmitButton()" *ngIf="tab == notificationSaleAdminTabs.ADD">
					<i class="fa fa-spinner fa-spin" *ngIf="isSubmitLoading"></i> <i class="fa fa-save" *ngIf="!isSubmitLoading"></i> Save
				</button>
			</div>
		</div>

		<div class="modal-body">
			<div *ngIf="tab === notificationSaleAdminTabs.ADD">
				<div class="mb-3 row">
					<label for="notificationType" class="col-sm-4 col-form-label">Select Notification Type</label>
					<div class="col-sm-8">
						<select class="form-select" id="notificationType" formControlName="notificationType" (change)="onNotificationTypeChange($event)">
							<option value="">{{ isLoading === true ? "Loading..." : "Select Notification Type..." }}</option>
							<option *ngFor="let type of notificationTypes" [value]="type.notificationTypeId">{{ type.name }}</option>
						</select>
					</div>
				</div>

				<div class="mb-3 row">
					<label for="notificationId" class="col-sm-4 col-form-label">Notification</label>
					<div class="col-sm-8">
						<div class="form-check form-check-inline">
							<input class="form-check-input"
										 type="checkbox"
										 id="inlineCheckboxEmail"
										 value="email"
										 (change)="onCheckboxChange('email')"
										 [formControl]="notificationForm.get('notificationMethods.email')">
							<label class="form-check-label" for="inlineCheckboxEmail">Email</label>
						</div>
						<div class="form-check form-check-inline">
							<input class="form-check-input"
										 type="checkbox"
										 id="inlineCheckboxSMS"
										 value="sms"
										 (change)="onCheckboxChange('sms')"
										 [formControl]="notificationForm.get('notificationMethods.sms')">
							<label class="form-check-label" for="inlineCheckboxSMS">SMS</label>
						</div>
					</div>
				</div>
				<div class="mb-3 row" *ngIf="tagLegendTable">
					<label for="notificationId" class="col-sm-4 col-form-label">Tag Legend</label>
					<div class="col-sm-8  col-form-label">
						<!--<div class="form-label" style="border: 1px solid lightgray">@SaleName  @DataType (i.e. X-ray, Scope Video, PDF Report)<br />@HIP@DataStatus (i.e. Approved/Denied))<br />@LOT@VetName<br />@ContactName@SaleAdmin<br />@Signature</div>-->
						<div class="form-input" style="border: 1px solid lightgray">
							<span [innerHTML]="tagLegendTable | safeHtml"></span>
						</div>
					</div>
				</div>

				<div class="mb-3 row">
					<label for="subjectId" class="col-sm-4 col-form-label">Email Subject Line</label>
					<div class="col-sm-8">
						<input type="text"
									 class="form-control"
									 id="subjectId"
									 placeholder=""
									 formControlName="emailSubject"
									 [attr.disabled]="!notificationForm.get('notificationMethods.email').value ? true : null" />
						<div *ngIf="notificationForm.get('notificationMethods.email').value
							 && notificationForm.get('emailSubject').hasError('required')
							 && (notificationForm.get('emailSubject').dirty || notificationForm.get('emailSubject').touched)"
								 class="text-danger pt-1">
							Email Subject is required
						</div>
					</div>
				</div>

				<div class="mb-3 row">
					<label for="bodyTextId" class="col-sm-4 col-form-label">Email Body Text</label>
					<div class="col-sm-8">
						<textarea class="form-control"
											id="bodyTextId"
											rows="5"
											formControlName="emailBody"
											[attr.disabled]="!notificationForm.get('notificationMethods.email').value ? true : null"></textarea>
						<div *ngIf="notificationForm.get('notificationMethods.email').value
							 && notificationForm.get('emailBody').hasError('required')
							 && (notificationForm.get('emailBody').dirty || notificationForm.get('emailBody').touched)"
								 class="text-danger pt-1">Email Body is required</div>
					</div>
				</div>

				<div class="mb-3 row">
					<label for="smsTextId" class="col-sm-4 col-form-label">SMS text</label>
					<div class="col-sm-8">
						<textarea class="form-control"
											id="smsTextId"
											rows="2"
											formControlName="smsText"
											[attr.disabled]="!notificationForm.get('notificationMethods.sms').value ? true : null"></textarea>
						<div *ngIf="notificationForm.get('notificationMethods.sms').value
							 && notificationForm.get('smsText').hasError('required')
							 && (notificationForm.get('smsText').dirty || notificationForm.get('smsText').touched)"
								 class="text-danger pt-1">SMS Text is required</div>
					</div>
				</div>
			</div>

			<div *ngIf="tab === notificationSaleAdminTabs.LIST">
				<div class="row" *ngIf="notificationSaleAdminRecords?.length !== notificationTypes?.length">
					<div class="col-md-12 text-end mb-3">
						<button type="button" class="btn btn-primary btn-sm" (click)="addNotification()"><i class="fa fa-plus"></i> Add</button>
					</div>
				</div>
				<div class="table-resposive">
					<table class="table table-borded">
						<thead>
							<tr>
								<td>Name</td>
								<!--<td>Email</td>
							<td>SMS</td>-->
								<td>Action</td>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let notificationSaleAdminRecord of notificationSaleAdminRecords">
								<td>
									<strong>{{ getNotificationName(notificationSaleAdminRecord.notificationTypeId)?.name }}</strong><br />
									{{ getNotificationName(notificationSaleAdminRecord.notificationTypeId)?.description }}
								</td>
								<!--<td>
								<span *ngIf="notificationSaleAdminRecord.isEmail">
									<i class='fa fa-check text-success ms-2'></i>
								</span>
								<span *ngIf="!notificationSaleAdminRecord.isEmail">
									<i class='fa fa-times text-danger ms-2'></i>
								</span>
							</td>
							<td>
								<span *ngIf="notificationSaleAdminRecord.isSMS">
									<i class='fa fa-check text-success ms-2'></i>
								</span>
								<span *ngIf="!notificationSaleAdminRecord.isSMS">
									<i class='fa fa-times text-danger ms-2'></i>
								</span>
							</td>-->
								<td>
									<a href="javascript:void(0)"> <i class='fa fa-edit text-primary ms-3' (click)="editNotification(notificationSaleAdminRecord)"></i></a>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>			
		</div>
	</div>
</form>
